module.exports = __webpack_public_path__ + "static/media/2025_Pangaea.47b9d75f.png";